export default {
  routes: [
    {
      name: 'profile',
      path: '/user',
      component: () => import('./views/TheProfile.vue'),
    },
  ]
}
